export type PageNamesProps = (typeof PageNames)[keyof typeof PageNames];

export const PageNames = {
  countrySelector: 'Country selector',
  home: 'Home',
  productOverview: 'Product overview',
  productOverviewEbikes: 'Product overview ebikes',
  productDetail: 'Product detail',
  productDetailEBikes: 'Product detail ebikes',
  productDetailPedalBikes: 'Product detail pedal bikes',
  productConfigure: 'Product configure',
  cookies: 'Cookies',
  notFound: '404',
} as const;
